module.exports = __webpack_public_path__ + "img/link.8763f395.svg";